
const types = {

    HTTP_PENDING_TYPES: 'HTTP_PENDING_TYPES',
    HTTP_ERROR_TYPES: 'HTTP_ERROR_TYPES',
    HTTP_SUCCESS_TYPES: 'HTTP_SUCCESS_TYPES',

   
}
const actions = {
    //HTTP
    startHTTPRequest: () => ({
        type: types.HTTP_PENDING_TYPES,
    }),
    stopHTTPRequestError: (error) => ({
        type: types.HTTP_ERROR_TYPES,
        error: error
    }),
    stopRequestSuccess: (payload) => ({
        type: types.HTTP_SUCCESS_TYPES,
        payload: payload
    }),

    
}



export { types, actions };
